/**
 *  상품 응답코드
 */
export const PRODUCT_RES_CODE = {
  /**
   *  상품의 데이터가 이미 수정된 데이터인 경우
   */
  ALREADY_EDITED_DATA: 108,
};
